import { useRecoilState } from 'recoil';

import { AccountState } from 'src/recoils/account';

export function useCurrentAccount() {
  const [currentAccount, setCurrentAccount] = useRecoilState(AccountState);

  return { currentAccount, setCurrentAccount };
}
